import { mass } from './mass.ts';
import type { Gym } from './plates.ts';

const pairs = (list: [number, number][]) => list.map(([w, n]) => ({ weight: mass(w), perSide: n }));

/** Default kg gym used in onboarding and every design mock (ui_ux spec 01 §6). */
export const DEFAULT_KG_GYM: Gym = {
  unit: 'kg',
  bar: mass(20),
  collar: 0,
  plates: pairs([[25, 2], [20, 2], [15, 1], [10, 2], [5, 2], [2.5, 2], [1.25, 2]]),
};

export const DEFAULT_LB_GYM: Gym = {
  unit: 'lb',
  bar: mass(45),
  collar: 0,
  plates: pairs([[45, 4], [35, 1], [25, 2], [10, 2], [5, 2], [2.5, 2]]),
};
